"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HouseIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function HouseIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M21 8.5V20H19V9.5L12.6001 4.69971C12.2476 4.43506 11.7529 4.43457 11.3994 4.7002L5.00001 9.49994V20H3V3H5V7L10.1997 3.1001C11.2607 2.30518 12.7407 2.30567 13.7998 3.09961L21 8.5H21ZM11 20H13V14H11V20Z",
    fill: "currentColor"
  }));
}